function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 11a6.5 6.5 0 1 0 6.5 6.5A6.508 6.508 0 0 0 6.5 11zm1.038 10.178c-.094.024-.288.109-.288.294v.279a.75.75 0 0 1-1.5 0V21.5a.248.248 0 0 0-.248-.247H5a.75.75 0 0 1 0-1.5h2.033a.592.592 0 0 0 .22-1.141l-2.063-.827a2.085 2.085 0 0 1 .343-3.978.333.333 0 0 0 .217-.328v-.228a.75.75 0 1 1 1.5 0v.25a.25.25 0 0 0 .25.25H8a.75.75 0 0 1 0 1.5H5.967a.592.592 0 0 0-.22 1.141l2.063.825a2.084 2.084 0 0 1-.272 3.961z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.414 3L21 .587A2 2 0 0 0 19.585 0H8a2 2 0 0 0-2 2v7.276a.247.247 0 0 0 .242.25 19.68 19.68 0 0 1 1.485.083A.247.247 0 0 0 8 9.36V2.251A.25.25 0 0 1 8.25 2h11.232a.249.249 0 0 1 .177.073l2.268 2.268a.248.248 0 0 1 .073.177v13.733a.25.25 0 0 1-.25.25h-7.108a.243.243 0 0 0-.241.21 7.935 7.935 0 0 1-.364 1.458.244.244 0 0 0 .228.331H22a2 2 0 0 0 2-2V4.415A2 2 0 0 0 23.414 3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 13.251A4.75 4.75 0 1 0 10.75 8.5a4.756 4.756 0 0 0 4.75 4.751zm0-8A3.25 3.25 0 1 1 12.25 8.5a3.254 3.254 0 0 1 3.25-3.249z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 9.251h1.768a.75.75 0 1 0 0-1.5H16.5a.252.252 0 0 1-.25-.251v-.767a.75.75 0 0 0-1.5 0V8.5a.75.75 0 0 0 .75.751z"
});

var SvgTimeClockFileCashBold = function SvgTimeClockFileCashBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgTimeClockFileCashBold;